// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"_0-z"};